import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import { Card, Table, Typography, DatePicker, Divider, Icon } from "antd";
import BookingTableRow from "../../components/dashboard/BookingTableRow";
import AdminCancelBookingModal from "../../components/modals/AdminCancelBookingModal";
import { SERVICES } from "../../constants/servicesList";
import { convertTimestampToMoment } from "../../utils";
import {
  RESULT_LIMIT,
  withManageBookingsProvider,
} from "../providers/BookingTableDataProvider";

const { Paragraph } = Typography;
const { RangePicker } = DatePicker;

class ManageBookingsTable extends Component {
  state = {
    showModal: false,
    record: null,
    recordId: null,
  };

  generateColumns = () => {
    return [
      {
        title: "Customer Name",
        dataIndex: "full_name",
        key: "full_name",
        render: (text, record) => {
          return text;
        },
      },
      {
        title: "Booking Date & Time",
        dataIndex: "date_time",
        key: "date_time",
        render: (text) => {
          const date = convertTimestampToMoment(text);

          return date.format("hh:mma - ddd Do MMM YYYY");
        },
      },
      {
        title: "Service",
        dataIndex: "selected_service",
        key: "selected_service",
        render: (text) => {
          if (text.includes("N/A")) {
            return text;
          }

          return _.get(SERVICES, [text, "service"], "Error");
        },
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        render: (text, record) => {
          const addressLine1 = _.get(record, "address_line_1");
          const city = _.get(record, "city");
          const postcode = _.get(record, "postcode");

          return `${addressLine1}, ${city}, ${postcode}`;
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text, record) => {
          let badgeProps = { status: "default", text: "Upcoming" };
          const { date_time, booking_cancelled } = record;

          if (date_time < moment()) {
            badgeProps = { status: "success", text: "Completed" };
          }

          if (booking_cancelled) {
            badgeProps = { status: "error", text: "Cancelled" };
          }

          return badgeProps.text;
        },
      },
      {
        title: "Is Manual Booking?",
        dataIndex: "manual_booking",
        key: "manual_booking",
        render: (text) => {
          if (text) {
            return <Icon type="check" />;
          }

          return "";
        },
      },
    ];
  };

  handleCloseCancelPopup = (success) => {
    this.setState(
      {
        record: null,
        recordId: null,
        showModal: false,
      },
      this.props.fetchBookings
    );
  };

  handleCancelClick = (record) => (e) => {
    const { uuidLookup } = this.props;

    this.setState({
      record,
      recordId: uuidLookup[record.uuid],
      showModal: true,
    });
  };

  render() {
    const { showModal, record, recordId } = this.state;
    const {
      isLoading,
      bookings,
      handleDateRangeChange,
      dateRange,
      rangeError,
    } = this.props;
    const columns = this.generateColumns();

    return (
      <>
        <Card title="Search Bookings">
          <Paragraph strong>Find bookings between these dates:</Paragraph>
          <RangePicker
            defaultValue={dateRange}
            format="ll"
            onChange={handleDateRangeChange}
            separator="-"
            allowClear={false}
            value={dateRange}
          />
          {rangeError && (
            <Paragraph type="danger" style={{ marginTop: 6 }}>
              The date range you have selected is too large, please select a
              smaller date range (max 31 days)
            </Paragraph>
          )}
          <Divider />
          <Table
            size="middle"
            bordered
            loading={isLoading}
            columns={columns}
            dataSource={bookings}
            expandedRowRender={(record) => (
              <BookingTableRow
                record={record}
                handleCancelClick={this.handleCancelClick}
              />
            )}
            footer={() => `Results limit: ${RESULT_LIMIT}`}
            pagination={false}
          />
        </Card>
        <AdminCancelBookingModal
          docId={recordId}
          data={record}
          visible={showModal}
          handleCancel={this.handleCloseCancelPopup}
        />
      </>
    );
  }
}

export default withManageBookingsProvider(ManageBookingsTable);
